import React from 'react';
import './AboutWalkDialogContent.scss';
// import logoFromWeb from "../../../assets/header-logo.svg";
import headerDImgSrc from '../../../assets/key-art-m.png';

export interface IAboutWalkDialogContentProps {
  imgSrc: string;
  title: string;
  subtitle: string;
  content: string;
}

const AboutWalkDialogContent: React.FC<IAboutWalkDialogContentProps> = ({
  imgSrc,
  title,
  subtitle,
  content,
}) => {
  return (
    <div className="dui-AboutWalkDialogContent">
      <div className="dui-AboutWalkDialogContent-img">
        <img src={imgSrc} alt={title} />
      </div>
      <div className="dui-AboutWalkDialogContent-title">
        <span>{title}</span>
        <span>{subtitle}</span>
      </div>
      <div
        className="dui-AboutWalkDialogContent-content"
        dangerouslySetInnerHTML={{ __html: content }}
      ></div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <a href="https://itrail.tw" target="_blank">
          <img
            style={{
              width: '100%',
            }}
            src={headerDImgSrc}
            alt="台灣千里步道協會"
          />
        </a>
      </div>
    </div>
  );
};
AboutWalkDialogContent.displayName = 'AboutWalkDialogContent';
export default AboutWalkDialogContent;
